export var TaskStatusColorEnum;
(function (TaskStatusColorEnum) {
    TaskStatusColorEnum["red"] = "red";
    TaskStatusColorEnum["amber"] = "amber";
    TaskStatusColorEnum["green"] = "green";
    TaskStatusColorEnum["blue"] = "blue";
    TaskStatusColorEnum["gray"] = "gray";
})(TaskStatusColorEnum || (TaskStatusColorEnum = {}));
export var TaskType;
(function (TaskType) {
    TaskType["task"] = "task";
    TaskType["story"] = "story";
    TaskType["epic"] = "epic";
})(TaskType || (TaskType = {}));
export const LABEL_BY_TASK_TYPE = {
    [TaskType.task]: "Task",
    [TaskType.story]: "Story",
    [TaskType.epic]: "Epic",
};
export var TaskReminderIdEnum;
(function (TaskReminderIdEnum) {
    TaskReminderIdEnum["dateTime"] = "dateTime";
    TaskReminderIdEnum["location"] = "location";
})(TaskReminderIdEnum || (TaskReminderIdEnum = {}));
export const DEFAULT_STATUSES = [
    { id: "todo", label: "To-Do", color: TaskStatusColorEnum.gray },
    { id: "inprogress", label: "In Progress", color: TaskStatusColorEnum.blue },
    { id: "inreview", label: "In Review", color: TaskStatusColorEnum.blue },
    { id: "done", label: "Done", color: TaskStatusColorEnum.green },
    { id: "wontdo", label: "Wont Do", color: TaskStatusColorEnum.red },
];
